// extracted by mini-css-extract-plugin
export default {"carousel":"carousel_carousel__af0CV","body":"carousel_body__af0CV","indicator":"carousel_indicator__af0CV","active":"carousel_active__af0CV","navigator":"carousel_navigator__af0CV"};